/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { AuthorisationApiConfiguration } from '../authorisation-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GrantResponse as ApiGrantResponse } from '../models/api/grant-response';
import { ListGrantsResponse as ApiListGrantsResponse } from '../models/api/list-grants-response';
import { deleteBoardGrant } from '../fn/grants/delete-board-grant';
import { DeleteBoardGrant$Params } from '../fn/grants/delete-board-grant';
import { deleteGlobalGrant } from '../fn/grants/delete-global-grant';
import { DeleteGlobalGrant$Params } from '../fn/grants/delete-global-grant';
import { deleteTenantGrant } from '../fn/grants/delete-tenant-grant';
import { DeleteTenantGrant$Params } from '../fn/grants/delete-tenant-grant';
import { grantBoard } from '../fn/grants/grant-board';
import { GrantBoard$Params } from '../fn/grants/grant-board';
import { grantGlobal } from '../fn/grants/grant-global';
import { GrantGlobal$Params } from '../fn/grants/grant-global';
import { grantTenant } from '../fn/grants/grant-tenant';
import { GrantTenant$Params } from '../fn/grants/grant-tenant';
import { listBoardGrants } from '../fn/grants/list-board-grants';
import { ListBoardGrants$Params } from '../fn/grants/list-board-grants';
import { listGlobalGrants } from '../fn/grants/list-global-grants';
import { ListGlobalGrants$Params } from '../fn/grants/list-global-grants';
import { listTenantGrants } from '../fn/grants/list-tenant-grants';
import { ListTenantGrants$Params } from '../fn/grants/list-tenant-grants';

@Injectable({ providedIn: 'root' })
export class GrantsService extends BaseService {
  constructor(config: AuthorisationApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listBoardGrants()` */
  static readonly ListBoardGrantsPath = '/v2/grants/boards/{boardId}';

  /**
   * List grants for board.
   *
   * List grants for board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listBoardGrants()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBoardGrants$Response(
    params: ListBoardGrants$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListGrantsResponse>> {
    return listBoardGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * List grants for board.
   *
   * List grants for board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listBoardGrants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBoardGrants(params: ListBoardGrants$Params, context?: HttpContext): Observable<ApiListGrantsResponse> {
    return this.listBoardGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListGrantsResponse>): ApiListGrantsResponse => r.body)
    );
  }

  /** Path part for operation `grantBoard()` */
  static readonly GrantBoardPath = '/v2/grants/boards/{boardId}';

  /**
   * Grant a board.
   *
   * Grant a board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `grantBoard()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  grantBoard$Response(
    params: GrantBoard$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiGrantResponse>> {
    return grantBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Grant a board.
   *
   * Grant a board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `grantBoard$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  grantBoard(params: GrantBoard$Params, context?: HttpContext): Observable<ApiGrantResponse> {
    return this.grantBoard$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiGrantResponse>): ApiGrantResponse => r.body)
    );
  }

  /** Path part for operation `deleteBoardGrant()` */
  static readonly DeleteBoardGrantPath = '/v2/grants/boards/{boardId}';

  /**
   * Delete grants for board.
   *
   * Delete grants for board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBoardGrant()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBoardGrant$Response(
    params: DeleteBoardGrant$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return deleteBoardGrant(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete grants for board.
   *
   * Delete grants for board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBoardGrant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBoardGrant(params: DeleteBoardGrant$Params, context?: HttpContext): Observable<void> {
    return this.deleteBoardGrant$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `listGlobalGrants()` */
  static readonly ListGlobalGrantsPath = '/v2/grants/global';

  /**
   * List global grants.
   *
   * List global grants
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listGlobalGrants()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGlobalGrants$Response(
    params?: ListGlobalGrants$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListGrantsResponse>> {
    return listGlobalGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * List global grants.
   *
   * List global grants
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listGlobalGrants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGlobalGrants(params?: ListGlobalGrants$Params, context?: HttpContext): Observable<ApiListGrantsResponse> {
    return this.listGlobalGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListGrantsResponse>): ApiListGrantsResponse => r.body)
    );
  }

  /** Path part for operation `grantGlobal()` */
  static readonly GrantGlobalPath = '/v2/grants/global';

  /**
   * Grant a global role.
   *
   * Grant a global role
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `grantGlobal()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  grantGlobal$Response(params: GrantGlobal$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return grantGlobal(this.http, this.rootUrl, params, context);
  }

  /**
   * Grant a global role.
   *
   * Grant a global role
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `grantGlobal$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  grantGlobal(params: GrantGlobal$Params, context?: HttpContext): Observable<void> {
    return this.grantGlobal$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `deleteGlobalGrant()` */
  static readonly DeleteGlobalGrantPath = '/v2/grants/global';

  /**
   * Delete a global grant.
   *
   * Delete a global grant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteGlobalGrant()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteGlobalGrant$Response(
    params: DeleteGlobalGrant$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return deleteGlobalGrant(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a global grant.
   *
   * Delete a global grant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteGlobalGrant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteGlobalGrant(params: DeleteGlobalGrant$Params, context?: HttpContext): Observable<void> {
    return this.deleteGlobalGrant$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `listTenantGrants()` */
  static readonly ListTenantGrantsPath = '/v2/grants/tenants/{tenantId}';

  /**
   * List grants for tenant.
   *
   * List grants for tenant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTenantGrants()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTenantGrants$Response(
    params: ListTenantGrants$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListGrantsResponse>> {
    return listTenantGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * List grants for tenant.
   *
   * List grants for tenant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTenantGrants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTenantGrants(params: ListTenantGrants$Params, context?: HttpContext): Observable<ApiListGrantsResponse> {
    return this.listTenantGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListGrantsResponse>): ApiListGrantsResponse => r.body)
    );
  }

  /** Path part for operation `grantTenant()` */
  static readonly GrantTenantPath = '/v2/grants/tenants/{tenantId}';

  /**
   * Grant tenant permissions to a user.
   *
   * Grant tenant permissions to a user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `grantTenant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  grantTenant$Response(
    params: GrantTenant$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListGrantsResponse>> {
    return grantTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * Grant tenant permissions to a user.
   *
   * Grant tenant permissions to a user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `grantTenant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  grantTenant(params: GrantTenant$Params, context?: HttpContext): Observable<ApiListGrantsResponse> {
    return this.grantTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListGrantsResponse>): ApiListGrantsResponse => r.body)
    );
  }

  /** Path part for operation `deleteTenantGrant()` */
  static readonly DeleteTenantGrantPath = '/v2/grants/tenants/{tenantId}';

  /**
   * Delete grants for tenant.
   *
   * Delete grants for tenant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTenantGrant()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTenantGrant$Response(
    params: DeleteTenantGrant$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return deleteTenantGrant(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete grants for tenant.
   *
   * Delete grants for tenant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTenantGrant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTenantGrant(params: DeleteTenantGrant$Params, context?: HttpContext): Observable<void> {
    return this.deleteTenantGrant$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
